import { WarningIcon } from '@shared/assets/icons';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface FormErrorToastProps {
  errorText: string;
}

export const FormErrorToast = ({ errorText }: FormErrorToastProps) => (
  <div {...stylex.props(styles.warningContainer)}>
    <WarningIcon width="16" height="16" />

    <div {...stylex.props(styles.warningText)}>
      <span>{errorText}</span>
    </div>
  </div>
);
